export const defaultHomePropsState = {
    loyaltyOpen: false,
    aboutOpen: false,
    bookingOpen: false,  
}